function getSupplyChainData() {
    return (
        {
        "SupplyChain": { 
            img: "https://media.deloitte.com/is/image/deloitte/ca175268_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/focus/supply-chain/supply-chain-agility-efficiency.html",
            content: "The new supply chain equilibrium",
            },
        "Government_trend":{ 
            img: "https://media.deloitte.com/is/image/deloitte/us175197_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/industry/public-sector/government-trends/2022/government-rebuilding-post-pandemic-world.html",
            content: "The 10 government trends reshaping the postpandemic world",
            },
        "Emerging_market": { 
            img: "https://media.deloitte.com/is/image/deloitte/glob176868-banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/economy/emerging-markets-outlook.html",
            content: "Emerging markets",
            },
        "Supply_Chain": { 
            img: "https://media.deloitte.com/is/image/deloitte/us164858_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/economy/us-china-trade-war-supply-chain.html",
            content: "Supply chain resilience in the face of geopolitical risks",
            },
        "Inflation": { 
            img: "https://www.deloitte.com/content/dam/insights/articles/2024/us175207_econ-econ-special-topic-global-inflation/content-images/us175207-figure1.jpg",
            link: "https://www2.deloitte.com/us/en/insights/economy/is-the-global-surge-in-inflation-here-to-stay.html",
            content: "Global surge in inflation",
            },
        "Friendshoring": { 
            img: "https://media.deloitte.com/is/image/deloitte/us175188_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/industry/public-sector/government-trends/2022/reshoring-global-supply-chains.html",
            content: `Reshoring and "friendshoring" supply chains`,
            },
        "Data Points": { 
            img: "https://www.deloitte.com/content/dam/insights/articles/2024/us164873_dim-data-points/content-images/us164873-economy.png",
            link: "https://www2.deloitte.com/us/en/insights/deloitte-insights-magazine/insights-data-points.html",
            content: "Data points: Bite-size insights from Deloitte research",
            },
        "Autonomous_Truck": { 
            img: "https://media.deloitte.com/is/image/deloitte/7031_banner-1:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/focus/future-of-mobility/autonomous-trucks-lead-the-way.html",
            content: "Autonomous trucks lead the way",
            },
        "Localization": { 
            img: "https://www.deloitte.com/content/dam/insights/articles/2024/us154463_cir-reshoring-and-greenfield-brownfield/content-images/us154463-figure1.jpg",
            link: "https://www2.deloitte.com/us/en/insights/topics/operations/reshoring-supply-chain.html",
            content: "Reshoring or localization on your mind?",
            },
        "Resilient_Health": { 
            img: "https://media.deloitte.com/is/image/deloitte/us164670-banner-425-x-425:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/industry/health-care/healthcare-supply-chain.html",
            content: "Key determinants for resilient health care supply chains",
            },
        "Sizzling_food_price": { 
            img: "https://www.deloitte.com/content/dam/insights/articles/2024/in164939_econ--economics-special-topic/content-images/in164939-figure1.jpg",
            link: "https://www2.deloitte.com/us/en/insights/economy/global-food-prices-inflation.html",
            content: "Sizzling food prices are leading to global heartburn",
            },
        }
    )
}

export default getSupplyChainData;